import S, { maybeShape } from 'common/service/sanctuary';
import React from 'react';
import { connect } from 'react-redux';
import { node } from 'prop-types';
import { Link } from 'found';
import Toolbar, { ToolbarRow, ToolbarSection } from 'common/mdc/toolbar';
import { ALIGN_START, ALIGN_END } from 'common/mdc/toolbar/section';
import { DrawerToggler } from 'common/mdc/drawer';
import Logo from 'common/assets/logo.svg';
import { getUser } from 'common/store/auth/selectors';
import AppSelector from './appSelector';
import UserProfile from './profile';

const Header = ({
  children,
  app,
  onAppChange,
  maybeUser,
  userMenu,
}) => (
  <Toolbar className="header" fixed>
    <ToolbarRow>
      <ToolbarSection align={ALIGN_START} shrink>
        <DrawerToggler />
      </ToolbarSection>
      <ToolbarSection align={ALIGN_START} shrink>
        <Link to="/" className="mdc-toolbar__logo page-title">
          <Logo />
        </Link>
      </ToolbarSection>
      <ToolbarSection align={ALIGN_START} >
        <AppSelector value={app} onChange={onAppChange} />
      </ToolbarSection>
      {children && (
        <ToolbarSection align={ALIGN_END} >
          {children}
        </ToolbarSection>
      )}
      {
        S.maybeToNullable(S.map(user => (
          <ToolbarSection align={ALIGN_END} shrink >
            <UserProfile user={user}>
              {userMenu}
            </UserProfile>
          </ToolbarSection>
        ), maybeUser))
      }
    </ToolbarRow>
  </Toolbar>
);

Header.propTypes = {
  children: node,
  maybeUser: maybeShape,
  userMenu: node,
};

Header.defaultProps = {
  children: null,
  userMenu: null,
};

export default connect(
  state => ({
    maybeUser: S.chain(S.I, S.eitherToMaybe(getUser(state))),
  }),
)(Header);
